import { Extension, Store } from '../types';
import * as R from 'ramda';

const STORE_FIELDS = ['id', 'sloc', 'store', 'store_api_uuid'];
const EXTENSION_FIELDS = ['active', 'code', 'dial_plan_id', 'id', 'name', 'overridden_code'];

export const serializeStore = (s: any): Store => ({
  ...R.pick<Store, string>(STORE_FIELDS, s),
  number: s.inbounds[0].number,
});

export const serializeExtension = (ext: any): Extension =>
  R.pick(EXTENSION_FIELDS, ext) as Extension;
